import { Transition } from "@headlessui/react";
import { FC, Fragment } from "preact/compat";
import { getChats } from "~/core/store";
import Content from "./Content";
import cn from "classnames";

const ChatPopup: FC = () => {
    const { popup, popupMinimised } = getChats();

    return (
        <Transition
            show={popup.value}
            as={Fragment}
            enterFrom="opacity-0 translate-y-8"
            enter="transition easy-in-out duration-200"
            leave="transition easy-in duration-100"
            leaveTo="opacity-0 translate-y-8"
        >
            <div className="fixed hidden right-4 bottom-4 lg:block">
                <div
                    className={cn(
                        "w-[360px] h-[400px] bg-white rounded-lg bg-white border border-gray-300 shadow-lg transition duration-300",
                        popupMinimised.value && "translate-y-[calc(100%-25px)]"
                    )}
                >
                    <Content />
                </div>
            </div>
        </Transition>
    );
};

export default ChatPopup;
